const ns = {};

/**
 * Klasse fuer Popups.
 */

/**
 * @param {string} url
 * @param {string} title
 * @param {number} width
 * @param {number} height
 * @param {bool} showMenu
 * @returns {Popup}
 */
ns.Popup = function(url, title, width, height, showMenu) {

    this.url = url;
    this.title = title;
    this.defaultWidth = 760;
    this.defaultHeight = 570;
    this.setWidth(width);
    this.setHeight(height);
    this.setShowMenu(showMenu);
};

/**
 * Setzt die Breite des Popups.
 *
 * @param {Number} width
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setWidth = function(width) {
    this.width = width;
};

/**
 * Setzt die Hoehe des Popups.
 *
 * @param {Number} height
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setHeight = function(height) {

    this.height = (typeof height !== 'undefined') ? height : this.defaultHeight;
    return this;
};

/**
 * Bestimmt, ob bei dem Popup ein Menue zu sehen sein soll.
 *
 * @param {Bool} showMenu
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.setShowMenu = function(showMenu) {

    this.showMenu = (showMenu === true) ? 'yes' : 'no';
    return this;
};

/**
 * Zeigt das Popup an.
 *
 * @returns {Popup.prototype}
 */
ns.Popup.prototype.show = function() {

	window.open(this.url, this.title, 'toolbar=no,location=no,directories=no,status=no,menubar=' +
        this.showMenu + ',scrollbars=yes,resizable=yes,copyhistory=no,width=' + this.width +
        ',height=' + this.height +',screenX=10,screenY=10,top=10,left=10');

    return this;
};

export default ns.Popup;
